
const BarStackedData = () => {

    var chartBar = []


    for (let y = 0; y < 3; y++) {
        chartBar.push(
            {
                datos: new Array(5).fill().map((e, i) => ([100 * Math.random()])),
                color: y < 1 ? 'red' : y > 1 ? 'green' : 'blue',
                name: 'name ' + y
            }
        )
    }
    var categories = ['Cat-1', 'Cat-2', 'Cat-3', 'Cat-4', 'Cat-5']

    return { chartBar: chartBar, categories: categories }
}



export default BarStackedData




